// import { NioOsSDK } from '@nio-fe/www-sdk'
import { Config3DWeb } from 'core'
import { getEnv } from '@common/utils'

// 对外导出vueuse库
export * from '@vueuse/core'

// 获取os sdk
let nioOsSDK
export const useNioOsSDK = async () => {
  if (!nioOsSDK) {
    // nioOsSDK = new NioOsSDK(getEnv(), {
    //   disableSignIn: true, // 暂时禁用登录
    //   apiPrefix: import.meta.env.DEV ? 'http://www-cn-local.nioint.com/:' + location.port : undefined
    // })
    // await nioOsSDK.setLocale({ lang: "zh", region: "CN" });
   if(window.NIONavigationSDK){
    const NavigationSDK = window.NIONavigationSDK
    nioOsSDK = new NavigationSDK({
      header: document.getElementById('nio-config-header'),
      env: getEnv(),
      disableSSO: true,
    })
   }
  }

  return nioOsSDK
}

// 返回3d实例
let config3DInstance
export const useConfig3D = (...arg) => {
  if (!config3DInstance) {
    config3DInstance = new Config3DWeb(...arg)
  }

  return config3DInstance
}